module.exports = __webpack_public_path__ + "img/sdg10.2f037f68.svg";